import React from "react";
import classes from "./record.module.scss";

interface RecordColumnsProps {
    main: React.ReactNode;
    /** The 340px right rail summarising the drawers. Stacks under main below ~1100px. */
    rail?: React.ReactNode;
    className?: string;
}

/** A record page's body: the main column plus an optional right rail. */
const RecordColumns: React.FC<RecordColumnsProps> = ({ main, rail, className }) => (
    <div className={`${classes.columns} ${className ?? ""}`}>
        <div className={`${classes.columnsInner} ${rail ? "" : classes.columnsNoRail}`}>
            <div className={classes.main}>{main}</div>
            {rail && <aside className={classes.rail}>{rail}</aside>}
        </div>
    </div>
);

export default RecordColumns;
